import { createContext, type ReactNode, useMemo } from 'react';
import type { User } from '@/types/roles';

const DEFAULT_USER: User = {
  id: '',
  name: '',
  email: '',
  role: 'credit-controller',
};

export interface AuthContextType {
  user: User;
}

export const AuthContext = createContext<AuthContextType>({ user: DEFAULT_USER });

interface AuthProviderProps {
  readonly user?: User;
  readonly children: ReactNode;
}

export function AuthProvider({ user = DEFAULT_USER, children }: AuthProviderProps) {
  const value = useMemo(() => ({ user }), [user]);
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
